export const ConfirmModalContainer = `grid grid-rows-3 grid-cols-1 items-center text-center`
